<template>
  <div class="card customer-personal-info">
    <div class="header border-bottom">
      <h5 class="text-primary font-weight-normal mb-0">Personal Information</h5>
    </div>
    <div class="body">
      <ValidationObserver v-slot="{ passes }" class="channel-right">
        <form @submit.prevent="passes(handleSubmit)" id="basic-form">
          <div class="edit-form">
            <div class="row">
              <div class="col-lg-6 col-12">
                <ValidationProvider
                  name="select_country"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div class="country-dropdown">
                    <div
                      class="form-group form-select multiselect-grp"
                      :class="{
                        errors: errors[0],
                        success:
                          personalInfo.countryofresidence &&
                          personalInfo.countryofresidence.length != 0 &&
                          !errors[0],
                      }"
                    >
                      <span class="float-label">
                        <label for="Country">Country of Residence*</label>
                        <multiselect
                          placeholder=""
                          v-model="personalInfo.countryofresidence"
                          :show-labels="false"
                          :options="countryList"
                          label="name"
                          track-by="name"
                          @select="setPrimaryNumberCountryCode"
                        >
                          <template slot="option" slot-scope="props">
                            <span
                              :class="
                                'flag-icon flag-icon-' +
                                props.option.flagCode +
                                ' fi-md fi-round '
                              "
                            ></span>
                            <div class="option__desc">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </template>
                        </multiselect>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && errors[0]"
                        ></i>
                        <i
                          class="fa fa-check"
                          v-if="
                            personalInfo.countryofresidence &&
                            personalInfo.countryofresidence.length != 0 &&
                            !errors[0]
                          "
                        ></i>
                      </span>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="salutation"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: personalInfo.salutation && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="salutation">Select Salutation*</label>
                      <multiselect
                        placeholder=""
                        v-model="personalInfo.salutation"
                        :show-labels="false"
                        label="name"
                        :options="salutation_options"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="personalInfo.salutation && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="first_name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !personalInfo.first_name,
                      success: personalInfo.first_name,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="personalInfo.first_name"
                        class="form-control"
                        id="first_name"
                        placeholder="First Name*"
                      />
                      <label for="first_name" class="control-label">
                        First Name*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !personalInfo.first_name"
                      ></i>
                      <i class="fa fa-check" v-if="personalInfo.first_name"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div class="form-group">
                  <span class="float-label">
                    <input
                      type="text"
                      class="form-control"
                      id="middle_name"
                      v-model="personalInfo.middle_name"
                      placeholder="Middle Name"
                    />
                    <label for="middle_name" class="control-label">
                      Middle Name
                    </label>
                    <div class="line"></div>
                  </span>
                </div>
                <ValidationProvider
                  name="last_name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !personalInfo.last_name,
                      success: personalInfo.last_name,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="personalInfo.last_name"
                        class="form-control"
                        id="last_name"
                        placeholder="Last Name*"
                      />
                      <label for="last_name" class="control-label">
                        Last Name*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !personalInfo.last_name"
                      ></i>
                      <i class="fa fa-check" v-if="personalInfo.last_name"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div class="form-group datepicker">
                  <span class="float-label">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text">Date of Birth</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate"
                        v-model="personalInfo.dob"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </span>
                </div>
                <div class="mb-2">
                  <div class="d-flex justify-content-between flex-wrap">
                    <label for="gender" class="control-label pr-2">
                      Gender: *
                    </label>
                    <div>
                      <label class="fancy-radio">
                        <input
                          name="gender2"
                          v-model="personalInfo.gender"
                          value="Male"
                          type="radio"
                          :checked="personalInfo.gender == 'Male'"
                        />
                        <span>
                          <i></i>
                          Male
                        </span>
                      </label>
                      <label class="fancy-radio">
                        <input
                          name="gender2"
                          v-model="personalInfo.gender"
                          value="Female"
                          type="radio"
                          :checked="personalInfo.gender == 'Female'"
                        />
                        <span>
                          <i></i>
                          Female
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <ValidationProvider
                  name="countryBirth"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: personalInfo.countryBirth && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="countryBirth">Country of Birth*</label>
                      <multiselect
                        placeholder=""
                        v-model="personalInfo.countryBirth"
                        :show-labels="false"
                        label="name"
                        :options="countryList"
                      >
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span
                              :class="
                                'flag-icon flag-icon-' +
                                props.option.flagCode +
                                ' fi-md fi-round '
                              "
                            ></span>
                            <span class="option__title">
                              {{ props.option.name }}
                            </span>
                          </div>
                        </template>
                      </multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="personalInfo.countryBirth && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>

                <ValidationProvider
                  name="contact_email"
                  rules="required|email"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors:
                        (errors.length && !personalInfo.contact_email) ||
                        errors[0],
                      success: personalInfo.contact_email && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="email"
                        v-model="personalInfo.contact_email"
                        class="form-control"
                        name="email1"
                        id="contact_email"
                        placeholder="Email*"
                      />
                      <label for="contact_email" class="control-label">
                        Email*
                      </label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="
                          (errors.length && !personalInfo.contact_email) ||
                          errors[0]
                        "
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="personalInfo.contact_email && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>

                <!-- Country Code and Mobile Number -->
                <ValidationProvider
                  name="Contact Mobile Number"
                  :rules="''"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: mobileObjectData?.valid == false,
                      success:
                        personalInfo.mobile_number && mobileObjectData?.valid,
                    }"
                  >
                    <div class="float-label">
                      <label for="primary_number" class="control-label">
                        Mobile
                      </label>
                      <vue-tel-input
                        :key="telInputKey"
                        v-model="personalInfo.mobile_number"
                        v-bind="primaryMobileNumber"
                        @validate="mobileInputValidate"
                        @input="handleMobilePhoneInput"
                        ref="telInput"
                        @keydown.native="restrictSpecialCharacter($event)"
                      >
                        <template v-slot:arrow-icon>
                          <span class="vti__dropdown-arrow">
                            {{ "▼" }}
                          </span>
                        </template>
                      </vue-tel-input>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="mobileObjectData?.valid == false"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="
                          mobileObjectData?.valid && personalInfo.mobile_number
                        "
                      ></i>
                    </div>
                    <span
                      class="text-danger error-msg"
                      v-if="
                        errors &&
                        isDisplayPhoneError &&
                        personalInfo.countryofresidence
                      "
                    >
                      {{ errors[0] }}
                    </span>
                  </div>
                </ValidationProvider>

                <div class="form-group">
                  <span class="float-label">
                    <input
                      type="text"
                      class="form-control"
                      id="telephone"
                      v-model="personalInfo.telephone"
                      placeholder="Telephone"
                    />
                    <label for="telephone" class="control-label">
                      Telephone
                    </label>
                    <div class="line"></div>
                  </span>
                </div>
                <ValidationProvider
                  name="remitergroup"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: personalInfo.remitergroup && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="remitergroup">Remitter Group</label>
                      <multiselect
                        placeholder=""
                        v-model="personalInfo.remitergroup"
                        :show-labels="false"
                        label="groupname"
                        track-by="groupid"
                        :options="remitgroupOption"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="personalInfo.remitergroup && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  name="accountstatus"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group form-select single-multiselect select-option-custom"
                    :class="{
                      errors: errors[0],
                      success: personalInfo.accountStatus && !errors[0],
                    }"
                  >
                    <span class="float-label">
                      <label for="accountstatus">Account Status*</label>
                      <multiselect
                        placeholder=""
                        v-model="personalInfo.accountStatus"
                        :show-labels="false"
                        label="value"
                        :options="accountStatuses"
                      ></multiselect>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && errors[0]"
                      ></i>
                      <i
                        class="fa fa-check"
                        v-if="personalInfo.accountStatus && !errors[0]"
                      ></i>
                    </span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column flex-md-row justify-content-center">
            <b-button
              variant="secondary btn-mw"
              size="lg"
              @click="handleCancel()"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
              size="lg"
              @click="isDisplayPhoneError = true"
            >
              Submit
            </b-button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapGetters } from "vuex";
import { ISLOADING } from "@/store/mutations.type";
import {
  UPDATE_CUSTOMER_PERSONAL_DETAILS,
  CUSTOMER_REMITER_GROUPS,
  GET_CUSTOMER_ACCOUNT_DETAILS,
  UPDATE_CUSTOMER_VERIFICATION,
} from "@/store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";
import parsePhoneNumber from "libphonenumber-js";
const { VueTelInput } = require("vue-tel-input");

export default {
  name: "PersonalInfo",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
    VueTelInput,
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
    accountStatuses: {
      type: Array,
      default: () => [],
    },
    customerDetails: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    personalInfo: {
      id: "",
      salutation: "",
      first_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      contact_email: "",
      username: "",
      dob: "",
      remitergroup: "",
      countryofresidence: null,
      countryBirth: null,
      telephone: "",
      mobile_number: "",
      accountStatus: null,
    },
    verificationData: null,
    salutation_options: [
      { name: "Mr", value: "Mr" },
      { name: "Mrs", value: "Mrs" },
      { name: "Ms", value: "Ms" },
      { name: "Miss", value: "Miss" },
      { name: "Dr", value: "Dr" },
      { name: "Prof", value: "Prof" },
      { name: "Revd", value: "Revd" },
      { name: "Pastor", value: "Pastor" },
      { name: "Hon", value: "Hon" },
      { name: "Capt", value: "Capt" },
      { name: "Bishop", value: "Bishop" },
      { name: "Col", value: "Col" },
      { name: "Flt.Lieut", value: "Flt.Lieut" },
      { name: "Other", value: "Other" },
    ],
    remitgroupOption: [],
    isDisplayPhoneError: false,
    mobileObjectData: null,
    telInputKey: "",
    primaryMobileNumber: {
      mode: "auto",
      defaultCountry: null,
      autoFormat: true,
      dropdownOptions: {
        showFlags: true,
        disabled: false,
        showDialCodeInSelection: true,
      },
    },
  }),
  computed: {
    ...mapGetters(["countryList"]),
  },
  mounted() {
    this.loadRemitterGroups();
    this.loadAccountStatus();
  },
  watch: {
    customerDetails: {
      handler(newVal) {
        if (newVal && this.remitgroupOption?.length > 0) {
          this.applyCustomerData();
        }
      },
      immediate: true,
    },
    countryList: {
      handler(newVal) {
        if (
          newVal?.length > 0 &&
          this.customerDetails &&
          !this.personalInfo.countryofresidence
        ) {
          this.applyCustomerData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadRemitterGroups() {
      try {
        const response = await this.$store.dispatch(CUSTOMER_REMITER_GROUPS);
        if (response.status == 200) {
          this.remitgroupOption = response.data.details;
        }
        if (this.customerDetails) {
          this.applyCustomerData();
        }
      } catch (error) {
        console.error("Error loading remitter groups:", error);
      }
    },
    async loadAccountStatus() {
      try {
        const response = await this.$store.dispatch(
          GET_CUSTOMER_ACCOUNT_DETAILS,
          this.customerId,
        );
        if (response.status === 200 && response.data.details) {
          const details = response.data.details;
          this.verificationData = details;
          this.personalInfo.accountStatus =
            this.accountStatuses.find(
              (option) => option.value === details.accountStatus,
            ) || null;
        }
      } catch (error) {
        console.error("Error loading account status:", error);
      } finally {
        this.$store.commit(ISLOADING, false);
      }
    },
    applyCustomerData() {
      const customer = this.customerDetails;
      if (!customer || !this.remitgroupOption?.length) return;

      let mobilenumber;
      let countryCode;
      const countryofresidence = customer.countryofResidence
        ? this.countryList.find(
            (item) => item.countryid === customer.countryofResidence,
          )
        : "";

      const mobileSource = customer.mobile || customer.phone || '';
      if (mobileSource) {
        try {
          const parsed = parsePhoneNumber(mobileSource);
          countryCode = parsed.country;
          mobilenumber = parsed.nationalNumber;
        } catch (error) {
          console.error("Error parsing phone number:", mobileSource, error);
          mobilenumber = mobileSource;
        }
      }

      if (!countryCode) {
        countryCode = countryofresidence.isocode;
      }

      this.primaryMobileNumber = {
        mode: "auto",
        defaultCountry: countryCode,
        autoFormat: true,
        dropdownOptions: {
          showFlags: true,
          disabled: false,
          showDialCodeInSelection: true,
        },
      };
      this.telInputKey = countryCode;

      this.personalInfo = {
        id: customer.id,
        salutation: this.salutation_options.filter(
          (item) => item.name === customer.title,
        )[0],
        first_name: customer.fname,
        middle_name: customer.mname,
        last_name: customer.lname,
        gender: customer.gender,
        contact_email: customer.email,
        dob: customer.dob,
        remitergroup: customer.remiter_group
          ? this.remitgroupOption.find(
              (item) => item.groupid === customer.remiter_group,
            )
          : "",
        countryofresidence: countryofresidence,
        countryBirth: customer.countryofBirth
          ? this.countryList.filter(
              (item) => item.countryid === customer.countryofBirth,
            )[0]
          : "",
        telephone: customer.mobile ? customer.phone : '',
        mobile_number: mobilenumber,
        accountStatus: this.personalInfo.accountStatus,
      };

      // Ensure vue-tel-input fires @validate so mobileObjectData gets populated
      this.$nextTick(() => {
        if (this.personalInfo.mobile_number && !this.mobileObjectData) {
          const currentVal = this.personalInfo.mobile_number;
          this.personalInfo.mobile_number = '';
          this.$nextTick(() => {
            this.personalInfo.mobile_number = currentVal;
          });
        }
      });
    },

    async handleSubmit() {
      if (this.personalInfo.mobile_number && !this.mobileObjectData?.valid) {
        this.isDisplayPhoneError = true;
        return;
      }

      let params = {
        id: this.customerId,
        title: this.personalInfo.salutation.value,
        fname: this.personalInfo.first_name,
        lname: this.personalInfo.last_name,
        middlename: this.personalInfo.middle_name,
        dob: this.personalInfo.dob,
        gender: this.personalInfo.gender,
        email: this.personalInfo.contact_email,
        phone: this.personalInfo.telephone,
        countryofResidence: this.personalInfo.countryofresidence.countryid,
        countryofBirth: this.personalInfo.countryBirth.countryid,
        rgroup: this.personalInfo.remitergroup.groupid,
        mobile: this.mobileObjectData?.number || '',
      };

      this.$store.commit(ISLOADING, true);

      try {
        const response = await this.$store.dispatch(
          UPDATE_CUSTOMER_PERSONAL_DETAILS,
          params,
        );

        if (response.status == 200) {
          if (this.personalInfo.accountStatus) {
            await this.$store.dispatch(UPDATE_CUSTOMER_VERIFICATION, {
              customerId: this.customerId,
              accountExpiryDate:
                this.verificationData?.accountExpiryDate || null,
              isVerified: Boolean(this.verificationData?.isVerified ?? false),
              passcodeVerified: Boolean(
                this.verificationData?.passcodeVerified ?? false,
              ),
              accountStatus: this.personalInfo.accountStatus.value,
              notifyRemiter: false,
            });
          }
          myFunction.showInfo(response.data.message, "success");
          this.isDisplayPhoneError = false;
        } else {
          if (response.data.detail) {
            myFunction.showInfo(response.data.detail, "error");
          } else {
            myFunction.showInfo(response.data.message, "error");
          }
        }
      } catch (error) {
        console.error("Error updating personal details:", error);
        myFunction.showInfo("An error occurred", "error");
      } finally {
        this.$store.commit(ISLOADING, false);
      }
    },

    handleCancel() {
      this.$router.push({ path: "/customer/list" });
    },

    restrictSpecialCharacter(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },

    setPrimaryNumberCountryCode(defaultCountry) {
      if (this.personalInfo.mobile_number) {
        return;
      }
      this.$refs.telInput.choose(defaultCountry.isocode);
      this.primaryMobileNumber.defaultCountry = defaultCountry.isocode;
      this.telInputKey = defaultCountry.isocode;
    },

    mobileInputValidate(phoneObject) {
      this.mobileObjectData = phoneObject;
    },

    handleMobilePhoneInput(_value, phoneObject) {
      if (phoneObject) {
        this.mobileObjectData = phoneObject;
      }
    },
  },
};
</script>

<style scoped></style>
